export default class GroupBase {
    constructor({ name, description }) {
        if (this.constructor === GroupBase) {
            throw new Error("GroupBase is an abstract class and cannot be instantiated directly.");
        }
        this.name = name;
        this.description = description;
    }
}
